import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_NEW_SUPPORTER_RECOMMENDATIONS = defineFcm('new_supporter_recommendations')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				top_tag_ids: {
					type: 'array',
					shape: {
						type: 'number',
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		top_tag_ids: [],
	})
	.toConfig({
		owner: 'squad-chameleon',
		scope: 'corgi-middle-end',
		context: 'New supporters PSF',
		description: 'Feature config to control whether we show a different set of recommendations for new supporters',
		import: false,
		template: {
			enabled: false,
			top_tag_ids: [],
		},
	});
